import { createClient } from '@supabase/supabase-js';

// Public project URL + publishable key — safe to ship in the browser.
// Access is controlled by Row Level Security on each table.
const SUPABASE_URL = 'https://gwfminvzqlagneuwsrxp.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_oD7eX-Sg-sKU54tRCrewTw_DQ340-aS';

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: { persistSession: false },
});

export type ContactMessage = {
  topic: string;
  name: string;
  email: string;
  phone: string;
  message: string | null;
  consent: boolean;
  page: string;
};

/** Stores one contact-form submission in the existing `leads` table. */
export async function sendContactMessage(msg: ContactMessage) {
  const { error } = await supabase.from('leads').insert(msg);
  if (error) throw error;
}
